import {detailServicesPath} from "../../Constants";
import axios from "axios";
import FileService from "../orders/orders/customer/FileService";

const restUrl = detailServicesPath + '/organizations/compositions'
const moduleCompositionsRestUrl = detailServicesPath + '/organizations/module-compositions'
const dependentModuleCompositionsRestUrl = detailServicesPath + '/organizations/dependent-module-compositions'

export default class CompositionController {
    static async get() {
        return axios.get(restUrl, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getById(id) {
        return axios.get(restUrl + "/" + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getForFulOrganization(orderId) {
        return axios.get(restUrl + "/for-ful-organization", {
            params: {
                orderId,
                forOrder: true,
            },
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }


    static async save(data) {
        return await axios.post(restUrl, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async edit(data, id) {
        return await axios.put(restUrl + '/' + id, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getModuleCompositionById(id) {
        return axios.get(moduleCompositionsRestUrl + "/" + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async patchModuleComposition(id, data) {
        return axios.patch(
            moduleCompositionsRestUrl + '/' + id,
            JSON.stringify(data),
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
    }

    /** PATCH …/module-compositions/{moduleCompositionId}/width */
    static async patchModuleCompositionWidth(moduleCompositionId, data) {
        return axios.patch(
            moduleCompositionsRestUrl + '/' + moduleCompositionId + '/width',
            JSON.stringify(data),
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
    }

    /** PATCH …/module-compositions/{id}/update-coordinate — 2D точка на медиа. */
    static async patchModuleCompositionCoordinate(moduleCompositionId, data) {
        return axios.patch(
            `${moduleCompositionsRestUrl}/${moduleCompositionId}/update-coordinate`,
            JSON.stringify(data),
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
    }

    /** PATCH …/module-compositions/{moduleCompositionRowId}/update-coordinate-3d */
    static async patchModuleCompositionCoordinate3d(
        moduleCompositionRowId,
        coordinateX3DPoint,
        coordinateY3DPoint,
    ) {
        if (moduleCompositionRowId == null || moduleCompositionRowId === "") {
            return Promise.reject(new Error("Не указан id module-composition"));
        }
        const x = Number(coordinateX3DPoint);
        const y = Number(coordinateY3DPoint);
        if (!Number.isFinite(x) || !Number.isFinite(y)) {
            return Promise.reject(new Error("Укажите coordinateX3DPoint и coordinateY3DPoint"));
        }
        const params = {
            coordinateX3DPoint: Math.round(x),
            coordinateY3DPoint: Math.round(y),
        };
        return axios.patch(
            `${moduleCompositionsRestUrl}/${moduleCompositionRowId}/update-coordinate-3d`,
            null,
            {
                params,
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
    }

    static async getDependentModuleCompositionById(id) {
        return axios.get(dependentModuleCompositionsRestUrl + "/" + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getForDependModuleComposition(compositionId) {
        return axios.get(moduleCompositionsRestUrl + "/get-for-depend-module-composition", {
            params: {
                compositionId,
            },
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async createDependentModuleComposition(moduleCompositionId, data) {
        return axios.post(
            dependentModuleCompositionsRestUrl,
            JSON.stringify(data),
            {
                params: {
                    moduleCompositionId,
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            },
        );
    }

    static async addDependentModuleComposition(id, moduleCompositionId) {
        return axios.patch(
            dependentModuleCompositionsRestUrl + "/" + id,
            [],
            {
                params: {
                    moduleCompositionId,
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            },
        );
    }

    static async module(compositionId, moduleId, data) {
        return await axios.patch(
            restUrl + '/' + compositionId,
            JSON.stringify(data),
            {
                params: {
                    moduleId,
                },
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
    }

    static async description(data, id) {
        return await axios.patch(restUrl + '/' + id + "/description", data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }

    static async setTableTop(id, nameTableTop, tableTopMaterialId) {
        return await axios.patch(restUrl + '/' + id + "/set-table-top?nameTableTop=" + nameTableTop + "&tableTopMaterialId=" + tableTopMaterialId, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setWallPanel(id, nameWallPanel, wallPanelMaterialId) {
        return await axios.patch(restUrl + '/' + id + "/set-wall-panel?nameWallPanel=" + nameWallPanel + "&wallPanelMaterialId=" + wallPanelMaterialId, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setFrontTop(id, nameFrontTop, frontTopMaterialId) {
        return await axios.patch(restUrl + '/' + id + "/set-front-top?nameFrontTop=" + nameFrontTop + "&frontTopMaterialId=" + frontTopMaterialId, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setFrontBottom(id, nameFrontBottom, frontBottomMaterialId) {
        return await axios.patch(restUrl + '/' + id + "/set-front-bottom?nameFrontBottom=" + nameFrontBottom + "&frontBottomMaterialId=" + frontBottomMaterialId, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setBodyTop(id, nameBodyTop, bodyTopMaterialId) {
        return await axios.patch(restUrl + '/' + id + "/set-body-top?nameBodyTop=" + nameBodyTop + "&bodyTopMaterialId=" + bodyTopMaterialId, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setBodyBottom(id, nameBodyBottom, bodyBottomMaterialId) {
        return await axios.patch(restUrl + '/' + id + "/set-body-bottom?nameBodyBottom=" + nameBodyBottom + "&bodyBottomMaterialId=" + bodyBottomMaterialId, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    /** PATCH …/compositions/{id}/set-texture — textureId из справочника /organizations/pictures */
    static async setTexture(id, compositionMaterialType, textureId) {
        return axios.patch(`${restUrl}/${id}/set-texture`, [], {
            params: {
                compositionMaterialType,
                textureId,
            },
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }

    static async delete(id) {
        await axios.delete(restUrl + '/' + id);
    }

    static async upload(files) {
        return uploadCompositionFile('/upload', files);
    }

    static async uploadModules(files) {
        return uploadCompositionFile('/upload-modules', files);
    }

    static async uploadModulesDepend(files) {
        return uploadCompositionFile('/upload-modules-depend', files);
    }

    static async uploadModulesDependModules(files) {
        return uploadCompositionFile('/upload-modules-depend-modules', files);
    }

}

const uploadCompositionFile = (path, files) =>
    axios.post(restUrl + path, FileService.getFormDataArray(files, "file"), {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });